import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { setUser } from "../redux/slice/userSlice";
import { useMutation } from "@tanstack/react-query";
import apis from "../services";
import { ChangePassword, Forgot, Login, SignUp } from "../components";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LandingPage from "./LandingPage";

const LOGINSCREEN = () => {
  const [showModal, setShowModal] = useState(true);
  const [modalType, setModalType] = useState("login");
    const [newPassword, setNewPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((store) => store.user);

  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user]);

  const openModal = (type) => {
    setModalType(type);
    setShowModal(true);
  };

  const switchToLogin = () => {
    setModalType("login");
  };

  const switchToSignUp = () => {
    setModalType("signup");
  };
  const switchToForgot = () => {
    setModalType("forgot");
  };

  //SIGN API CALL
  const { mutate: mutateSignup, isPending } = useMutation({
    mutationFn: apis.signup,
    onError: function (error) {
      const errorMessage =
        error.response?.data?.email?.[0] || "An error occurred";
      // console.log("error", error);
      toast.error(errorMessage);
    },
    onSuccess: ({ data: signupSucess, status }) => {
      console.log("signupSucessfully!!:", signupSucess);
      if (signupSucess?.success) {
        toast.success(signupSucess?.message);
        setModalType("login");
        setShowModal(true);
      }
    },
  });

  //LOGIN API CALL
  const { mutate: mutateLogin, isPending: isloadingLogin } = useMutation({
    mutationFn: apis.login,
    onError: function (error) {
      // console.log("error", error);
      toast.error(error?.message);
    },
    onSuccess: ({ data: loginSucess, status }) => {
      // console.log("loginSucessfully!!:", loginSucess);
      if (loginSucess?.success) {
        toast.success(loginSucess?.message);
        navigate("/");
        setShowModal(false);
        dispatch(setUser(loginSucess?.data));
        localStorage.setItem("token", loginSucess?.token);
      }
    },
  });

  //FORGOT API CALL
  const { mutate: mutateForgot, isPending: isLoadingForgot } = useMutation({
    mutationFn: apis.sendPasswordResetEmail,
    onError: (error) => {
      // console.log("erroceh", error);
      toast.error(error?.message || "Failed to send reset email");
    },
    onSuccess: (response) => {
      // console.log("RESPONSE", response);
      if (response?.status) {
        toast.success(response?.data?.message);
        setNewPassword(true);
        // setResetPassword(false);
      } else {
        toast.error(response?.message || "Failed to send reset email");
      }
    },
  });
  return (
    <>
      <LandingPage />

      {showModal && (
        <div className="modal">
          {modalType === "login" && (
            <Login
              showLogin={modalType === "login"}
              setShowLogin={setShowModal}
              onSwitchToSignUp={switchToSignUp}
              onSwitchToForgot={switchToForgot}
              mutateLogin={mutateLogin}
              isPending={isloadingLogin}
            />
          )}
          {modalType === "signup" && (
            <SignUp
              showSignUp={modalType === "signup"}
              setShowSignUp={setShowModal}
              onSwitchToLogin={switchToLogin}
              mutateSignup={mutateSignup}
              isPending={isPending}
            />
          )}
          {modalType === "forgot" && (
            <Forgot
              showForgot={modalType === "forgot"}
              setShowForgot={setShowModal}
              onSwitchToLogin={switchToLogin}
              mutateForgot={mutateForgot}
              isPending={isLoadingForgot}
            />
          )}
        </div>
      )}

      <ChangePassword
        newPassword={newPassword}
        setNewPassword={setNewPassword}
      />
    </>
  );
};

export default LOGINSCREEN;
